/**
 * Custom nav labels: data-next-label / data-prev-label on slide.
 */

const CUSTOM_LABEL_SEL = '.custom-nav-label';

export function setupCustomNavLabels(): void {
  if (typeof Reveal === 'undefined' || typeof Reveal.getCurrentSlide !== 'function') return;
  const Rev = Reveal;

  function ensureLabelSpan(btn: Element, kind: 'prev' | 'next'): Element {
    let span = btn.querySelector(CUSTOM_LABEL_SEL);
    if (!span) {
      span = document.createElement('span');
      span.className = 'custom-nav-label';
      if (kind === 'prev') {
        btn.appendChild(span);
      } else {
        btn.insertBefore(span, btn.firstChild);
      }
    }
    return span;
  }

  function getControlsRoot(): Document | Element {
    if (typeof Rev.getRevealElement === 'function') {
      const el = Rev.getRevealElement();
      if (el) return el;
    }
    return document;
  }

  function updateControlLabels(): void {
    const slide = Rev.getCurrentSlide?.();
    if (!slide) return;
    const root = getControlsRoot();
    const nextBtn = root.querySelector?.('.controls .navigate-right') ?? document.querySelector('.reveal .controls .navigate-right');
    const prevBtn = root.querySelector?.('.controls .navigate-left') ?? document.querySelector('.reveal .controls .navigate-left');
    const nextLabel = slide.getAttribute('data-next-label');
    const prevLabel = slide.getAttribute('data-prev-label');
    if (nextBtn) {
      const s = ensureLabelSpan(nextBtn, 'next');
      s.textContent = nextLabel || '';
      nextBtn.classList.toggle('has-custom-label', !!nextLabel);
    }
    if (prevBtn) {
      const s = ensureLabelSpan(prevBtn, 'prev');
      s.textContent = prevLabel || '';
      prevBtn.classList.toggle('has-custom-label', !!prevLabel);
    }
  }

  Rev.on?.('slidechanged', updateControlLabels);
  Rev.on?.('ready', () => {
    updateControlLabels();
    setTimeout(updateControlLabels, 0);
  });
  updateControlLabels();
  setTimeout(updateControlLabels, 0);
}
